import { Form, FormProps } from "@/components/form";
import { localNow } from "@/shared/local-now";
import { z } from "zod/v4";
import { getArticulo } from "../../articulos/api/get-articulo";
import { getAllArticulos } from "../../articulos/api/get-all-articulos";
import { ArticuloMovimientoTipo } from "@/shared/types/articulo-movimiento";

export const articuloMovimientoFormSchema = z.object({
    fecha: z.iso.datetime({ local: true, message: "Este campo es requerido" }).default(localNow()),
    tipo: z.number({ message: "Este campo es requerido" }),
    descripcion: z.string(),
    articuloId: z.string().nonempty("Este campo es requerido"),
    cantidad: z.number({ message: "Este campo es requerido" }),
})

export default function ArticuloMovimientoForm({
    form,
    ...props
}: FormProps<z.input<typeof articuloMovimientoFormSchema>>) {
    return <Form gap={3} form={form} {...props}>
        <Form.DatePicker name="fecha" label="Fecha" />
        <Form.Select name="tipo" label="Tipo">
            <Form.Select.Option value={ArticuloMovimientoTipo.Entrada}>Entrada</Form.Select.Option>
            <Form.Select.Option value={ArticuloMovimientoTipo.Salida}>Salida</Form.Select.Option>
        </Form.Select>
        <Form.ModelComboBox name="articuloId" label="Artículo" get={getArticulo} getAll={getAllArticulos} />
        <Form.NumberField name="cantidad" label="Cantidad" decimalScale={0} />
        <Form.TextField name="descripcion" label="Motivo" multiline rows={3} />
        <Form.SubmitButton>Guardar</Form.SubmitButton>
    </Form>
}